import React from 'react'
import { getExternalLinkProps } from '../../utils'
import StyledButton from './StyledButton'
import { ButtonProps, variants, sizes } from './types'

function Button({
  startIcon,
  style,
  endIcon,
  children,
  external = false,
  isLoading = false,
  disabled = false,
  white,
  testId,
  variant = variants.PRIMARY,
  size = sizes.MD,
  ...props
}: ButtonProps) {
  const internalProps = external ? getExternalLinkProps() : {}
  const isDisabled = isLoading || disabled

  return (
    <StyledButton
      {...internalProps}
      {...props}
      variant={variant}
      size={size}
      isLoading={isLoading}
      disabled={isDisabled}
      style={style}
      white={white}
      data-testid={testId}
    >
      {React.isValidElement(startIcon) && (
        <div style={{ marginRight: children ? '8px' : '0px' }}>{React.cloneElement(startIcon)}</div>
      )}
      {children}
      {React.isValidElement(endIcon) && (
        <div style={{ marginLeft: children ? '8px' : '0px' }}>{React.cloneElement(endIcon)}</div>
      )}
    </StyledButton>
  )
}

export default Button
